<template>
  <div class="chart-group" :class={open:isOpen}>
    <slot></slot>
    <div class="buttons">
      <btn-main class="open -plus" v-show="!isOpen" @click.prevent="toggle">もっと見る</btn-main>
      <btn-main class="close -minus" v-show="isOpen" @click.prevent="toggle">閉じる</btn-main>
    </div>
  </div>
</template>

<script>

import BtnMain from '../button/BtnMain'
export default {
  name: 'chart-group',
  components: {BtnMain},
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: this.open
    }
  },
  methods: {
    toggle: function () {
      // this.open = !this.open
      this.isOpen = !this.isOpen
      // this.$emit('open', this.isOpen)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.chart-group {
  >.buttons {
    padding-top: 20px;
    text-align: center;
    display: none;
    @include mq-up(md){
      padding-top: 30px;
    }
  }
  &.toggle {
    >.buttons {
      display: block;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/charts/ChartGroup.vue